import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import React from "react";
import { v4 as uuidv4 } from "uuid";

const months = [{value: "Month to Month"}];
for(let i=1; i<=100; i++){
    months.push({value: `${i} Month`})
}

function Financials({options, financials, setFinancials }) {

  const addFinancial = () => {
    const newFinancial = { id: uuidv4(), ownerId: "", percentOwned: "", contractExpires: "" };
    setFinancials([...financials, newFinancial]);
  };

  const removeFinancial = (id) => {
    const updatedFinancials = financials.filter((item) => item.id !== id);
    setFinancials(updatedFinancials);
  };

  const handleChange = (value, name, id) => {
    const updatedFinancials = financials.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setFinancials(updatedFinancials);
  };

  const onDateChange = (value, name, id) => {
    const updatedFinancials = financials.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value.format("YYYY-MM-DD") };
      }
      return item;
    });
    setFinancials(updatedFinancials);
  };
  return (
    <>
      {financials.map((item) => (
        <Row gutter={[8,0]} key={item.id}>
          <Col span={10}>
            <Form.Item key={item.id} name={`owner${item.id}`}>
              <Select
                value={item.owner}
                onChange={(value) => handleChange(value, 'ownerId', item.id)}
                options={options}
                showSearch
                placeholder="Select..."
              />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item key={item.id} name={`percentOwned${item.id}`}>
             <Input
              value={item.percentOwned}
              onChange={(e) => handleChange(e.target.value, 'percentOwned', item.id)}
              suffix="%"
            />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item key={item.id} name={`contractExpires${item.id}`}>
              <DatePicker
                value={item.contractExpires}
                onChange={(value) => onDateChange(value, 'contractExpires', item.id)}
                style={{width: "100%"}}
              />
            </Form.Item>
          </Col>
          <Col span={1}>
            {financials.length > 1 && (
              <Button className="roundSmallButton" onClick={() => { removeFinancial(item.id) }} type="primary" shape="circle" icon={<i className="fa-sharp fa-solid fa-xmark"></i>} size={"small"} />
            )}
          </Col>
        </Row>
      ))}
        <Button className="addPropertyGroupButton" type="primary" onClick={()=>addFinancial()} size={"small"} icon={<i className="fa-solid fa-circle-plus" ></i>} style={{width:"100%"}}> Add Another Owner</Button>
    </>
  );
}

export default Financials;
